<template>
  <div class="block-howitworks">
    <bimContainer>
      <bimCol cols=12 md=10 class="mx-auto">
        <bim-text adaptive type=h4 bold class="mb-12">Как это работает?</bim-text>
        <div class="steps d-flex justify-center flex-wrap">
          <div
            v-for="step of steps"
            :key="step.title"
            class="steps__item step"
          >
            <div class="step__image-wrapper d-flex align-center justify-center">
              <img alt="" :src="step.image" />
            </div>
            <bim-text adaptive type=desc bold class="step__count mt-6 mb-1">{{ step.count }} шаг</bim-text>
            <bim-text adaptive type=main bold v-html="step.title"></bim-text>
          </div>
        </div>
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"
import bimCol from "@bimlib/components/bimCol"
const img_catalog = "/dist/assets/front_white/img/landing_estimate/"
export default {
  name: "",
  components: {
    bimContainer,
    bimCol,
  },
  data() {
    return {
      steps: [
        {
          count: 1,
          title: `
            Вы загружаете XML/GSFX файл с документацией
            <a href="#download-documentation" class="step__link">Загрузить сейчас</a>
          `,
          image: img_catalog + "s-2.svg",
        },
        {
          count: 2,
          title: "Мы анализируем его с помощью искуственного интеллекта",
          image: img_catalog + "s-3.svg",
        },
        {
          count: 3,
          title: "Выдаем список продукции со ссылками на сайт продукта, с указанной ценой для снятия скриншота",
          image: img_catalog + "s-4.svg",
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.block-howitworks {
  padding: 64px 59px;
  background-color: $white-color-50;
}

.steps {
  .steps__item {
    @media screen and (min-width: $breakpoint-xs) {
      flex: 1 0 100%;
      &:not(:last-child) {
        margin-bottom: 34px;
      }
    }
    @media screen and (min-width: $breakpoint-lg) {
      flex: 1 0 47%;
      &:nth-child(odd) {
        margin-right: 34px;
      }
      &:last-child {
        margin-right: 0;
      }
      &:nth-child(n - 2) {
        margin-bottom: 34px;
      }
    }
    @media screen and (min-width: $breakpoint-xl) {
      flex: 1;
      &:not(:last-child) {
        margin-right: 34px;
      }
    }
  }

  .step {
    .step__image-wrapper {
      background-color: $white-color;
      box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.03);
      border-radius: 8px;
      padding: 20px;
    }
    .step__count {
      text-transform: uppercase;
      color: $primary-color; 
    }
    ::v-deep .step__link {
      color: $primary-color;
      display: block;
      margin-top: 4px;
      font-weight: normal;
      line-height: 1.5;
      letter-spacing: 0.2px;
    }
  }
}
</style>
